import { Component, OnInit } from '@angular/core';
import { ChargingStationDto } from '@dto/chargingStationDto';
import { Roles } from '@enums/roles.enum';
import { ChargingStation } from '@models/charging-station';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthenticationService } from '@services/authentication/authentication.service';
import { ChargingStationsService } from '@services/entity/charging-stations.service';

@Component({
  selector: 'app-bidi-select-charging-station',
  templateUrl: './bidi-select-charging-station.component.html',
  styleUrls: ['./bidi-select-charging-station.component.scss']
})
export class BidiSelectChargingStationComponent implements OnInit {

  chargingStationDtos: ChargingStationDto[] = [];
  selectedStations: ChargingStationDto[] = [];
  public preSelectedStations: ChargingStationDto[] = [];
  public customerId: number | null = null;

  role: Roles

  constructor(
    private chargingStationsService: ChargingStationsService,
    private authenticationService: AuthenticationService,
    public activeModal: NgbActiveModal
  ) { }

  async ngOnInit() {
    this.role = this.authenticationService.getRole();

    this.chargingStationDtos = await this.getBidiChargingStationDtos();

    this.selectedStations = this.chargingStationDtos.filter(dto =>
      this.preSelectedStations.some(pre => pre.id === dto.id)
    );
  }

  async getBidiChargingStationDtos(): Promise<ChargingStationDto[]> {
    let chargingStations: ChargingStationDto[] = [];

    try {
      if (this.role === 'Customer') {
        // Ladestationen für den aktuellen Kunden abrufen
        chargingStations = await this.chargingStationsService
          .getChargingStationsOfCurrentCustomer()
          .toPromise();
      } else {
        // Ladestationen für einen bestimmten Kunden (customerId) abrufen
        chargingStations = await this.chargingStationsService
          .getChargingStationsOfCustomer(this.customerId)
          .toPromise();
      }

      // Nur Ladestationen zurückgeben, deren Profil bidirektionales Laden ermöglicht
      return chargingStations.filter(cs => cs.profile.isBidi);
    } catch (error) {
      console.error('Fehler beim Abrufen der Ladestationen:', error);
      // Im Fehlerfall eine leere Liste zurückgeben
      return [];
    }
  }



  isStationSelected(station: ChargingStationDto): boolean {
    return this.selectedStations.some(s => s.id === station.id);
  }


  toggleSelection(station: ChargingStationDto, isChecked: boolean): void {
    if (isChecked && !this.selectedStations.some(s => s.id === station.id)) {
      this.selectedStations.push(station);
    }
    else if (!isChecked) {
      this.selectedStations = this.selectedStations.filter(
        s => s.id !== station.id
      );
    }
    console.log("this.selectedStations", this.selectedStations);
  }


  saveSelection() {
    this.activeModal.close(this.selectedStations);
  }


  closeDialog() {
    this.activeModal.dismiss();
  }










}




